import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import SuccessModal from "../utils/SuccessModal";

const SignUpBuyer = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false)

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleEnquire = async () => {
    setLoading(true)
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/enquire`, 
        {
          name: data.name,
          email: data.email,
          mobile: data.mobile,
          org: data.org
        }
      )
      setOpen(true);
      setData();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  };

  return (
    <div className="App" style={{position: 'relative'}}>
      {loading && <div className="loading-div"></div> }
      <div className="border-container">
        <form>
          <Typography variant="h4" mb={5}>
            Enquire Now
          </Typography>
          <label htmlFor="name">Name</label>
          <input
            type="email"
            name="name"
            id="name"
            onChange={handleChange}
          />
          <label htmlFor="email">Email ID</label>
          <input
            type="email"
            name="email"
            id="email"
            onChange={handleChange}
          />
          <label htmlFor="mobile">Mobile Number</label>
          <input
            type="number"
            name="mobile"
            id="mobile"
            onChange={handleChange}
          />
          <label htmlFor="org">Organization Name</label>
          <input
            type="text"
            name="org"
            id="org"
            onChange={handleChange}
          />
          <Button className="btn-contained" fullWidth onClick={handleEnquire} disabled={loading}>
            {loading ? "Submitting..." : "Enquire Now"}
          </Button>
        </form>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "30%",
          }}
        >
          <Box>
            <Link to={"/signup"} style={{ fontSize: "12px" }}>
              Sign Up As Vendor
            </Link>
          </Box>
          <Box>
            <Link to={"/"} style={{ fontSize: "12px" }}>
              Sign In
            </Link>
          </Box>
        </Box>

        <SuccessModal open={open} handleClose={() => setOpen(false)} msg={"Thanks for enquiring with Procdigi, our team will get back to you soon."} />
      </div>
    </div>
  );
};

export default SignUpBuyer;
